import { Component, Input } from '@angular/core';
import { InvoiceTemplate2Component } from './template2/invoice-template2.component';

@Component({
  selector: 'app-invoice-desktop',
  template: '<app-invoice-template2 [invoiceData]="invoiceData" [lang]="lang" [pdfLink]="pdfLink"></app-invoice-template2>'
})
export class InvoiceDesktopComponent {
  @Input() invoiceData: any;
  @Input() lang: 'en' | 'ar' | 'he' = 'en';
  @Input() pdfLink: string | null = null;
}
